import { IState } from '../../store';

export const getNewbuildingAdvantages = (state: IState) => {
  return state.offerData?.newObject?.advantages || [];
};
